var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFEBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C20.3098 21 19.75 20.441 19.75 19.75V12.25H12.25C11.5598 12.25 11 11.6914 11 11C11 10.3086 11.5598 9.75 12.25 9.75H21C21.6902 9.75 22.25 10.309 22.25 11V19.75C22.25 20.4414 21.6914 21 21 21Z",
    fill: "#E53451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.75 14.0195L11.8829 21.8867C11.6399 22.1289 11.32 22.25 11 22.25C10.6801 22.25 10.3602 22.1279 10.1165 21.8838C9.62817 21.3955 9.62817 20.6045 10.1165 20.1162L17.9844 12.25H19.75V14.0195Z",
    fill: "#E53451"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFail);
export default __webpack_public_path__ + "static/media/payment-fail.0d8891c42897eb43489aa63e49e8e7e3.svg";
export { ForwardRef as ReactComponent };